export { ArtistHeader } from './ArtistHeader';
